import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAsyncDebounce } from "react-table";
import { FaCog, FaArrowRight } from "react-icons/fa";
import SettingsModal from "../SettingsModal";

export function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  allColumns,
  latestSearchId,
}) {
  const navigate = useNavigate();
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 300);

  const [isModalDisplayed, setIsModalDisplayed] = useState(false);

  useEffect(() => {
    isModalDisplayed && (document.body.style.overflow = 'hidden');
    !isModalDisplayed && (document.body.style.overflow = 'unset');
  }, [isModalDisplayed]);

  const handleSettingsClick = () => {
    setIsModalDisplayed(true);
  }

  const closeButtonClick = () => {
    setIsModalDisplayed(false);
  }

  return (
    <>
      {isModalDisplayed && <SettingsModal
        allColumns={allColumns}
        closeButtonClick={closeButtonClick}
      />}
      <div className="table-options-container">
        <div className="settings-container">
          <button onClick={handleSettingsClick} className="settings-btn">
            <FaCog className="settings-icon" />
          </button>
        </div>
        <div className="search-container">
          <h2>Search:</h2>
          <input
            value={value || ""}
            onChange={(e) => {
              setValue(e.target.value);
              onChange(e.target.value);
            }}
            placeholder={`${count} records...`}
          />
        </div>
        <button
          className="view-saved-btn"
          disabled={!latestSearchId}
          title={latestSearchId ? 'Open saved list' : 'List not saved yet'}
          onClick={() =>
            latestSearchId &&
            navigate(`/list-viewer/business/${latestSearchId}`)
          }
        >
          <FaArrowRight style={{ marginRight: 4 }} />
          View in Saved Lists
        </button>
      </div>
    </>
  );
}